import React, { FC, useMemo } from 'react';
import { IFilterType } from '../../../../../../types/ProfileTypes';
import { ProfileUtils } from '../../../utils/ProfileUtils';
import appStore from '../../../../../../stores/AppStore';

interface IProps {
  filter: IFilterType;
  index: number;
  onChange: (value: any) => void;
  advance?: boolean;
  inDrawer?: boolean;
  getValueOnSelectMenuItem?: boolean;
  beforeKey?: string;
}
export const Item: FC<IProps> = ({
  filter,
  index,
  onChange,
  advance,
  inDrawer,
  getValueOnSelectMenuItem,
  beforeKey
}) => {
  const item = useMemo(() => {
    return ProfileUtils.renderFilterInForm(
      filter,
      `${beforeKey ? beforeKey : 'queryFilter'}-${filter.field}-${index}`,
      onChange,
      advance,
      inDrawer,
      undefined,
      undefined,
      getValueOnSelectMenuItem
    );
  }, [
    JSON.stringify(filter.value),
    filter?.dateType,
    JSON.stringify(filter?.filters),
    filter?.source,
    filter?.typeSource === 'ARRAY_CONTEXT' && appStore.filterContext.hasOwnProperty(filter.source)
  ]);

  return <>{item}</>;
};
